/**
 * Text processing utilities for Auth0 Universal Login
 * Handles template string replacements in screen texts
 */

const STRING_TEMPLATE_REPLACEMENT_MAP: Record<string, string> = {
  "${clientName}": "iFIT",
  "${companyName}": "iFIT",
  "${appName}": "iFIT",
};

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Processes texts object to replace placeholders using REPLACEMENT_MAP
 * @param texts - The texts object containing strings to process
 * @param clientName - Optional client name to replace with "iFIT" (case-sensitive)
 */
export function processTexts(
  texts?: Record<string, string> | null,
  clientName?: string
): void {
  if (!texts) return;
  const replacementMap = { ...STRING_TEMPLATE_REPLACEMENT_MAP };

  if (clientName && clientName.trim() !== "") {
    replacementMap[clientName] = "iFIT";
  }

  Object.keys(texts).forEach((key) => {
    if (typeof texts[key] === "string") {
      let value = texts[key];
      Object.entries(replacementMap).forEach(([placeholder, replacement]) => {
        value = value.replace(
          new RegExp(escapeRegExp(placeholder), "g"),
          replacement
        );
      });
      texts[key] = value;
    }
  });
}
